module.exports = __webpack_public_path__ + "img/us.c4e86dfb.svg";